import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Seo from './seo';

/* Caminho do arquivo estatico gerado pelo react-snap: nao e uma rota que o usuario digitou. */
const PRERENDER_PATH = '/404.html';
const UNKNOWN_PATH = '/unknown';

interface AvailableRoute {
    path: string;
    label: string;
    description: string;
}

const AVAILABLE_ROUTES: AvailableRoute[] = [
    { path: '/', label: '~/home', description: 'todas as postagens' },
    { path: '/apis', label: '~/apis', description: "API's publicas" },
    { path: '/blog', label: '~/blog', description: 'artigos e tutoriais' },
    { path: '/contact', label: '~/contact', description: 'enviar mensagem' },
    { path: '/social', label: '~/social', description: 'redes sociais' }
];

const NotFound = () => {

    const { pathname } = useLocation();
    const attemptedPath = pathname === PRERENDER_PATH ? UNKNOWN_PATH : pathname;

    return (
        <div className="notfound">
            <Seo
                title="404"
                description="Pagina nao encontrada."
                path="/404"
                noIndex
            />
            <h1 className="visually-hidden">404 - Pagina nao encontrada</h1>
            <div className="terminal-prompt" style={{ width: '100%' }}>
                <span className="terminal-prompt-line">
                    <span className="prompt-user">user</span>
                    <span className="prompt-at">@</span>
                    <span className="prompt-host">cesarcastro</span>
                    <span className="prompt-sep">:</span>
                    <span className="prompt-path">~</span>
                    <span className="prompt-dollar">$</span>
                    <span className="prompt-cmd">cd {attemptedPath}</span>
                    <span className="cursor"></span>
                </span>
            </div>
            <div className="notfound-content">
                <p className="nf-error">
                    <span className="nf-error-label">bash: cd: </span>
                    <span className="nf-error-path">{attemptedPath}</span>
                    <span className="nf-error-reason">: No such file or directory</span>
                </p>

                <p className="nf-code" aria-hidden="true">404</p>

                <div className="nf-routes">
                    <p className="nf-routes-cmd">ls ~/ --available</p>
                    <ul className="nf-routes-list">
                        {AVAILABLE_ROUTES.map(route => (
                            <li key={route.path}>
                                <Link to={route.path} className="nf-route">
                                    <span className="nf-route-perm">drwxr-xr-x</span>
                                    <span className="nf-route-path">{route.label}</span>
                                    <span className="nf-route-desc"># {route.description}</span>
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <p className="nf-exit">exit 404</p>
            </div>
        </div>
    )
}

export default NotFound;
